import axios from 'axios';

const $api = axios.create({
    withCredentials: true,
})

$api.interceptors.request.use((config) => {
    config.headers.authorization = `Bearer ${localStorage.getItem('jwt-token')}`
    return config
})

$api.interceptors.response.use((config) => {
    return config;
},   async (error) => {
    const originalRequest = error.config
    if (error.response.status == 401) {
        try {
            const response = await axios.get('http://213.139.209.236:5000/api/refresh', {withCredentials: true})
            localStorage.setItem('jwt-token', response.data.accessToken)
            return $api.request(originalRequest)
        }
        catch (e) {
            console.log('Не авторизован!')
        }

    }
})

export default $api